const carmaAi = {
    en: {
      carma_ai:{
        more: 'More...',
        less: 'Less...',
        nav: {
          ai_filtration: 'AI Filtration',
          ai_summary: 'AI Summary',
          noor: 'NOOR'
        },
        form: {
          labels: {
            prompt: 'Prompt:',
            noor_context: 'Context'
          }
        },
        messages: {
          context_update_success: 'Context for NOOR updated successfully',
          success: 'Open AI posts created successfully',
          delete_success: 'Open AI post deleted successfully',
          images_not_supported: 'This model does not support image analyzing'
        },
        modal: {
          title: 'Confirm Delete',
          message: 'Are you sure you want to delete?'
        },
        filtration: {
          name: 'Section Name',
          priority: 'Priority',
          tags: 'Tags',
          private_tags: 'Private Tags',
          exclude_tags: 'Exclude Tags',
          exclude_private_tags: 'Exclude Private Tags',
          media_type: 'Media Type',
          relevancy: 'Relevancy',
          country: 'Country',
          language: 'Language',
          tiers: 'Tiers',
          outlet_groups: 'Outlet Groups',
          outlets_multiple: 'Outlets',
          prompt: 'Prompt',
          volume_cap: 'Volume Cap',
          sort_by: 'Sort by',
          relevancy_scope: 'Relevancy Scope',
          relevancy_name: 'Relevancy Name',
          scope: 'Scope',
          action_tags: 'Add Tags',
          pipeline_enabled: 'Enabled in pipeline',
          pipeline_enabled_tooltip: 'If enabled this rule will be used at pipeline level to add the action tags',
          custom_industry: 'Enabled Custom Industry',
          create_tag: {
            name: 'Name',
            category: 'Category',
            is_private: 'Private'
          },
          scopes: {
            all: 'All Scopes',
            ER: 'ER',
            RTA: 'RTA',
            curation: 'Curation',
            newsletter: 'Newsletter',
            social: 'Social'
          },
          sort_options: {
            datetime_asc: 'Published Time ASC',
            datetime_desc: 'Published Time DESC', 
            created_asc: 'Captured Time ASC',
            created_desc: 'Captured Time DESC',
            outletname_asc: 'Outlet Name ASC',
            outletname_desc: 'Outlet Name DESC',
            word_asc: 'Word Count ASC',
            word_desc: 'Word Count DESC',
            tag_asc: 'Tags ASC',
            tag_desc: 'Tags DESC',
            impression_asc: 'Impressions ASC',
            impression_desc: 'impressions DESC',
            ave_asc: 'AVE ASC',
            ave_desc: 'AVE DESC',
            mozrank_asc: 'Domain Authority ASC',
            mozrank_desc: 'Domain Authority DESC',
            engagement_asc: 'Engagement ASC',
            engagement_desc: 'Engagement DESC',
            followers_asc: 'Followers ASC',
            followers_desc: 'Followers DESC',
            relevancy_asc: 'Relevancy ASC',
            relevancy_desc: 'Relevancy DESC',
          },
          table: {
            id: 'Id',
            prompt: 'Prompt',
            name: 'Name'
          },
          actions: 'Actions'
        },
        summaries: {
          form: {
            labels: {
              headline_language: 'Headline Language',
              headline_prompt: 'Enable Headline Prompt',
              headline_prompt_text: 'Headline',
              language: 'Summary Language'
            },
            placeholders: {
              headline_language: 'Select Headline Language',
              language: 'Select Summary Language'
            },
            tooltips: {
              headline_language: 'This applies to the headline and only works when headline prompt is disabled. It will not be summarized, but will be translated into the selected language.',
              headline_prompt: 'Enabling this will disable headline language and the AI will generate a headline for the summary based on the content provided in the prompt.'
            }
          },
          scopes: {
            all: 'All Scopes',
            ER: 'ER',
            coding: 'Coding'
          },
          table: {
            id: 'Id',
            prompt: 'Prompt',
            name: 'Name'
          }
        },
        projects: {
          title: 'Projects',
          nav: 'Projects',
          search_placeholder: 'Project or client name',
          table: {
            project: 'Project',
            client: 'Client'
          }
        },
        stories: {
          title: 'Stories',
          nav: 'Client Dashboard Stories',
          breadcrumb_root: 'Client Dashboard Stories',
          breadcrumb_projects: 'Projects',
          breadcrumb_wizard: 'Client Dashboard Stories - Generator',
          tabs: {
            overview: 'Stories',
            prompt_studio: 'Prompt Studio',
            backfills: 'Backfills',
            prompts: 'Prompts',
            audits: 'Activity',
          },
          admin: {
            title: 'Administration',
            breadcrumb: 'Administration',
            button: 'Administration',
            tabs: {
              backfills: 'Backfills',
              prompts: 'Prompts',
            },
            prompts: {
              placeholder: 'Prompt administration is coming soon.',
            },
          },
          prompts: {
            title: 'Prompts',
            empty: 'No prompts found.',
            loading: 'Loading prompts',
            preview_prompt: 'Preview Prompt',
            preview_modal_title: 'Preview — {label}',
            preview_description: 'This is the assembled prompt preview. Article headline and body are runtime placeholders.',
            preview_loading: 'Loading prompt…',
            preview_failed: 'Failed to load prompt preview. Please try again.',
            usage: 'Usage',
            usage_modal_title: 'Generation usage',
            usage_model: 'Model',
            usage_version: 'v{version}',
            usage_stage_config: 'Configuration',
            usage_stage_prompt: 'Prompt',
            usage_tokens_in: 'Input tokens',
            usage_tokens_cached: 'Cached tokens',
            usage_tokens_out: 'Output tokens',
            usage_tokens_reasoning: 'Reasoning tokens',
            usage_tokens_total: 'Total tokens',
            usage_duration: 'Duration',
            usage_generated_at: 'Generated',
            usage_thinking: 'Thinking',
            usage_empty: 'This stage has not been generated yet.',
            usage_none: 'No generation usage recorded for this prompt.',
            undelete: 'Undelete',
            undelete_confirm_title: 'Undelete prompt',
            undelete_confirm_message: '{label} will appear in Prompt Studio again. Continue?',
            undelete_success: 'Prompt restored to Prompt Studio.',
            undelete_failed: 'Failed to undelete prompt. Please try again.',
            table: {
              project: 'Project',
              client: 'Client',
              version: 'Prompt',
              status: 'Status',
              active_period: 'Active period',
              stories: 'Stories',
              articles: 'Articles',
              stories_articles: 'Stories / articles',
              skipped: 'Skipped',
              tokens: 'Total tokens',
              thinking: 'Thinking',
              updated: 'Updated',
              updated_by: 'Updated by',
              actions: 'Actions',
            },
            view_counts: 'View counts',
            counts_loading: 'Loading counts…',
            counts_failed: 'Failed to load counts. Please try again.',
          },
          prompts_control: {
            nothing_live: 'Nothing live',
            live_coding: 'Live · coding new articles',
            active_since: 'Active since {date} · published by {name}',
            articles_coded: 'Articles',
            stories_stat: 'Stories',
            irrelevant_stat: 'Skipped',
            deactivate: 'Deactivate…',
            deactivate_title: 'Deactivate {name}?',
            deactivate_confirm: 'Deactivate',
            deactivate_point_stop: 'Incoming articles stop using this prompt.',
            deactivate_point_kept: 'Existing stories stay as they are and are not deleted.',
            deactivate_point_resume: 'This prompt is saved and you can activate it again later.',
            activate: 'Activate…',
            coverage_title: 'Coverage',
            coverage_today: 'Today',
            coverage_window: '{from} → {to}',
            coverage_legend_live: 'Live',
            coverage_legend_past: 'Past',
            coverage_legend_gap: 'Nothing live',
            coverage_expand: 'Click to expand · {label}',
            coverage_collapse: 'Click again to close',
            coverage_gap_note: 'Incoming articles are not being processed. Activate a prompt to close this gap.',
            coverage_stories: 'Stories',
            coverage_articles: 'Articles',
            coverage_backfill_note: '{name} backfill is running ({range}) — not shown on this bar.',
            coverage_backfill_note_plain: 'A backfill is running — not shown on this bar.',
            deactivate_success: 'Prompt deactivated. New articles will not be coded until another version is published.',
            nothing_live_title: 'No prompt is live — new articles are not being processed',
            nothing_live_detail_deactivated: '{label} was deactivated on {date} by {name}. Its stories are kept. Publish a version to resume coding.',
            nothing_live_detail_fresh: 'This project has no prompt yet. Articles will be coded once a version is published.',
            nothing_live_cta_publish: 'Publish a version…',
            nothing_live_cta_studio: 'Go to Prompt Studio',
            empty_title: 'No prompt versions yet',
            empty_body: 'Write a prompt in Prompt Studio, save it as a draft, then publish it here to start coding new articles.',
            versions_title: 'Versions',
            new_draft: '+ New draft',
            new_draft_success: 'New draft version created.',
            new_draft_failed: 'Failed to create new draft. Please try again.',
            publish: 'Publish…',
            publish_title: 'Publish {name} for new articles?',
            publish_confirm: 'Publish',
            publish_point_replace: '{name} stops coding new articles now (its active period and stories are kept).',
            publish_point_immediate: 'This version starts coding incoming articles immediately.',
            publish_point_no_backfill: 'Past articles are not re-processed unless you also run a backfill.',
            publish_point_revert: 'You can publish a previous version again at any time.',
            backfill: 'Backfill…',
            backfill_title: 'Backfill a past range with {name}?',
            backfill_confirm: 'Start backfill',
            backfill_point_range: 'Runs only on the date range you choose; the live version keeps coding new articles.',
            backfill_point_replace: 'Articles in the range are re-coded with this version — earlier coding on those articles is replaced.',
            backfill_point_progress: 'Progress shows here and in Backfills.',
            edit: 'Edit',
            edit_as_new_draft: 'Edit as new draft',
            duplicate_as_draft: 'Duplicate as draft',
            view_progress: 'View progress',
            cancel_run: 'Cancel run',
            status_live: 'Live',
            status_draft: 'Draft',
            status_inactive: 'Inactive',
            status_finishing_backfill: 'Finishing backfill',
            period_not_live: 'Not live yet',
            period_from: 'From',
            period_to: 'To',
            period_now: 'Today',
            table: {
              version: 'Version',
              status: 'Status',
              active_period: 'Active period',
              stories_articles: 'Stories / articles',
              skipped: 'Skipped',
              updated: 'Updated',
              updated_by: 'Updated by',
              actions: 'Actions',
            },
            stories_articles_ratio: '{ratio} articles per story',
            stories_articles_ratio_none: 'No stories from {articles} articles',
          },
          audits: {
            title: 'Activity',
            empty: 'No activity found.',
            filter_all: 'All actions',
            date_range: 'Date range',
            user: 'User',
            user_placeholder: 'Search users',
            groups: {
              stories: 'Stories',
              prompts: 'Prompts',
              backfill: 'Backfill',
            },
            table: {
              when: 'When',
              who: 'Who',
              action: 'Action',
              details: 'Details',
            },
            actions: {
              STORY_MERGE: 'Merged stories',
              STORY_RENAME: 'Renamed story',
              STORY_DELETE: 'Deleted stories',
              STORY_ARTICLE_ADD: 'Added articles',
              STORY_ARTICLE_REMOVE: 'Removed articles',
              STORY_EXPORT: 'Exported stories',
              ARTICLE_EXPORT: 'Exported articles',
              SKIPPED_ARTICLE_EXPORT: 'Exported skipped articles',
              STORY_RISK_SENTIMENT: 'Updated risk / sentiment',
              STORY_RISK_SENTIMENT_UNLOCKED: 'Unlocked risk / sentiment',
              PROMPT_ONBOARDING: 'Onboarding',
              PROMPT_RISK_RUBRIC_UPDATE: 'Updated risk rubric',
              PROMPT_SENTIMENT_GUIDE_UPDATE: 'Updated sentiment guide',
              PROMPT_GENERATE: 'Generated prompt',
              PROMPT_PUBLISH: 'Activated prompt',
              PROMPT_DEACTIVATE: 'Deactivated prompt',
              PROMPT_NEW_VERSION: 'New prompt version',
              PROMPT_DISCARD: 'Discarded draft',
              PROMPT_RENAME: 'Renamed prompt',
              PROMPT_HIDE: 'Archived prompt',
              PROMPT_UNHIDE: 'Restored prompt',
              STORY_BACKFILL_ENQUEUE: 'Enqueued backfill',
            },
            details: {
              rename: '{oldName} → {newName}',
              target: 'Target {targetStoryId}',
              sources: 'Sources {sourceStoryIds}',
              jobs: 'Jobs {jobIds}',
              deleted_ids: '{deletedIds}',
              story: 'Story {storyId}',
              added_ids: 'Added {addedIds}',
              removed_ids: 'Removed {removedIds}',
              skipped: '{count} skipped',
              story_deleted: 'Story deleted',
              story_count: '{storyCount} stories',
              story_ids: '{storyIds}',
              article_ids: '{articleIds}',
              prompt_id: 'Prompt {promptId}',
              version: 'Version {version}',
              article_count: '{articleCount} articles',
              date_range: '{dateFrom} – {dateTo}',
              job: 'Job {jobId}',
              scope_all: 'All',
              scope_selected: 'Selected',
              source_manual: 'Manual',
              source_date_range: 'Date range',
              unlocked: 'formula',
              risk_change: 'Risk {old} → {new}',
              sentiment_change: 'Sentiment {old} → {new}',
              risk_change_label: 'Risk',
              sentiment_change_label: 'Sentiment',
              risk_unlocked: 'Unlocked risk (was {old})',
              sentiment_unlocked: 'Unlocked sentiment (was {old})',
              risk_unlocked_prefix: 'Unlocked risk (was',
              sentiment_unlocked_prefix: 'Unlocked sentiment (was',
            },
          },
          backfills: {
            title: 'Backfills',
            empty: 'No backfills found.',
            refresh: 'Refresh',
            refreshing: 'Refreshing…',
            duration_tooltip: 'Duration {duration}',
            table: {
              project: 'Project',
              client: 'Client',
              user: 'Started by',
              source: 'Source',
              date_range: 'Date range',
              status: 'Status',
              started: 'Started',
              ended: 'Ended',
              articles: 'Articles',
            },
            source: {
              manual: 'Manual',
              date_range: 'Date range',
            },
            status: {
              running: 'Running',
              completed: 'Completed',
              failed: 'Failed',
            },
          },
          overview: {
            stories: 'Stories',
            articles: 'Articles',
            skipped: 'Skipped',
            stories_tooltip: 'The large number is all stories. The matching count uses the filters in the bar below this card — including the published date range.',
            articles_tooltip: 'The large number is all articles linked to a story. The matching count uses the filters in the bar below this card — including the published date range.',
            skipped_tooltip: 'The number of articles that skipped story generation due to failing relevance criteria.',
            live_strip_live: 'Live · {name}',
            live_strip_nothing: 'No prompt is live',
            live_strip_go_prompts: 'Go to Prompts',
            charts: {
              sentiment: 'Sentiment',
              risk: 'Risk',
              percent_of_total: '{percent}% of {total} total',
              article_count_title: 'Articles per story',
              article_count_p25: 'p25',
              article_count_p50: 'p50',
              article_count_p75: 'p75',
              article_count_p95: 'p95',
              article_count_iqr: 'IQR',
              article_count_iqr_tooltip: 'p75 − p25',
              media_subtype: 'Media type',
              story_count: 'Stories',
              more_title_articles: 'Article Statistics',
              more_title_skipped: 'Skipped Dashboard Articles',
              more_title_stories: 'Story Statistics',
              more_tooltip_articles: 'More Article Statistics',
              more_tooltip_skipped: 'Skipped Dashboard Articles',
              more_tooltip_stories: 'More Story Statistics',
              status: 'Status',
              country: 'Outlet Countries',
              country_others: 'Others',
              prompt_version: 'Prompt',
              similar: 'Similar',
              span_title: 'Story span',
              span_stats_title: 'Span (days)',
              span_1: '1 day',
              span_2_7: '2-7 days',
              span_8_30: '8-30 days',
              span_31_90: '31-90 days',
              span_91_plus: '91+ days',
              span_axis_1: '1',
              span_axis_2_7: '2-7',
              span_axis_8_30: '8-30',
              span_axis_31_90: '31-90',
              span_axis_91_plus: '91+',
              first_published_month: 'First published',
              published_min: 'First',
              published_max: 'Last',
              published_range_title: 'Published',
              published_range_tooltip: 'All-time earliest and latest published dates (UTC)',
              volume_title: 'Article volume',
              volume_sentiment_title: 'Sentiment over time',
              volume_risk_title: 'Risk over time',
              volume_range_title: 'Published range',
              empty: 'No data',
              section_title: 'Charts',
              chart_type_label: 'Chart type',
              chart_type_bars: 'Bars',
              chart_type_line: 'Line',
              chart_type_stacked: 'Stacked',
              chart_type_grouped: 'Grouped',
              chart_type_heatmap: 'Heatmap',
              others_nested: 'Others',
              others_expand: 'Show remaining',
              others_back: 'Back',
              others_top: 'Top',
              percent_of_day: '{percent}% of day',
              volume_filter_showing: 'Showing {label}',
              volume_filter_full_range: 'Full range',
              filter_banner: 'Filtered to: {label} · {count} articles in range ({allTime} all time)',
              filter_banner_clear: 'Clear',
              filter_empty: 'No articles on {label} for this story.',
            },
            filtered_matching: '{count} matching filters',
            filtered_matching_article_filters: '{count} matching article filters',
            filtered_on_matching_stories: '{count} on matching stories',
            filtered_with_matching_articles: '{count} with matching articles',
            loading_stories: 'Loading stories',
            time_just_now: 'just now',
            time_few_minutes_ago: 'a few minutes ago',
            empty_stories: 'No stories found for this project.',
            empty_stories_setup_title: 'No stories set up yet',
            empty_stories_setup_body: 'Generate stories for this project in Prompt Studio.',
            empty_stories_setup_cta: 'Go to Prompt Studio',
            empty_stories_filtered: 'No stories match your filters',
            empty_stories_clear_filters: 'Clear filters',
            empty_articles: 'No articles found for this project.',
            empty_skipped: 'No skipped articles for this project.',
            rename: 'Rename',
            rename_modal_title: 'Rename story',
            rename_success: 'Story renamed successfully.',
            rename_failed: 'Failed to rename story. Please try again.',
            rename_cnf_conflict: 'The name you chose conflicts with "{name}". Pick a different name or merge the two stories.',
            edit_risk_sentiment: 'Edit Risk / Sentiment',
            edit_risk_sentiment_modal_title: 'Edit risk and sentiment',
            edit_risk_sentiment_success: 'Story risk and sentiment updated.',
            edit_risk_sentiment_failed: 'Failed to update risk and sentiment. Please try again.',
            edit_risk_sentiment_value_required: 'Choose a value for each field set to Set manually.',
            keep_current: 'Keep current',
            set_manually: 'Set manually',
            current_label: 'Current',
            lock_copy_both: 'This will lock risk and sentiment. New articles still join the story and keep their own scores — they just won\'t change these locked values until you unlock.',
            lock_copy_risk: 'This will lock risk only. New articles still join the story and keep their own scores — they just won\'t change locked risk until you unlock.',
            lock_copy_sentiment: 'This will lock sentiment only. New articles still join the story and keep their own scores — they just won\'t change locked sentiment until you unlock.',
            lock_copy_none: 'Nothing will be locked. Risk and sentiment will use the live formula, including articles that arrived while locked.',
            delete: 'Delete',
            delete_modal_title: 'Delete story | Delete stories',
            delete_confirm_message: 'Are you sure you want to delete "{name}"? | Are you sure you want to delete {count} stories?',
            delete_bulk_confirm_message: 'Are you sure you want to delete 1 story? | Are you sure you want to delete {count} stories?',
            delete_success: 'Story deleted successfully. | {count} stories deleted successfully.',
            delete_failed: 'Failed to delete story. Please try again.',
            delete_stale_count: 'The story count changed. Refresh the list and try again.',
            name_required: 'Story name is required.',
            name_too_long: 'Story name must be at most {max} characters.',
            open_article: 'Open article in Bodhi',
            open_parent_article: 'Open parent article in Bodhi',
            view_all_articles: 'View all {count} articles',
            view_all_stories: 'View all {count} stories',
            in_period_count: '{count} in this range',
            all_time_count: '{count} all time',
            story_rationale: 'Rationale',
            model_id: 'Model',
            generating_prompt: 'Prompt',
            add_articles: 'Add articles',
            add_articles_panel_title: 'Add articles to story',
            add_articles_panel_helper: 'Search project articles to add to "{story}".',
            add_articles_search_placeholder: 'Search by headline or article ID…',
            add_articles_empty: 'No articles found.',
            add_articles_badge_in_story: 'In story',
            add_articles_badge_added: 'Added',
            add_articles_added_title: 'Articles to add ({count})',
            add_articles_risk_required: 'Select risk',
            add_articles_sentiment_required: 'Select sentiment',
            add_articles_remove: 'Remove',
            add_articles_submit: 'Add to story',
            add_articles_in_progress: 'Adding to story…',
            add_articles_success: 'Article added to story. | {count} articles added to story.',
            add_articles_error: 'Failed to add articles to story. Please try again.',
            story_articles_panel_title: 'Story Articles',
            story_articles_panel_helper: 'Articles linked to "{story}".',
            story_articles_eyebrow: 'Story articles',
            article_stories_panel_title: 'Article Stories',
            article_stories_panel_helper: 'Stories linked to "{headline}".',
            remove_article: 'Remove from story',
            remove_article_modal_title: 'Remove article from story?',
            remove_article_confirm: 'Remove "{headline}" from "{story}"?',
            remove_article_success: 'Article removed from story.',
            remove_article_failed: 'Failed to remove article from story. Please try again.',
            empty_story_articles: 'No articles linked to this story.',
            empty_article_stories: 'No stories linked to this article.',
            bulk_actions: {
              merge: 'Merge',
              export: 'Export',
              delete: 'Delete',
            },
            export_success: 'Stories exported successfully.',
            export_failed: 'Failed to export stories. Please try again.',
            export_articles_success: 'Articles exported successfully.',
            export_articles_empty: 'No articles found to export.',
            export_articles_failed: 'Failed to export articles. Please try again.',
            export_skipped_success: 'Skipped articles exported successfully.',
            export_skipped_empty: 'No skipped articles found to export.',
            export_skipped_failed: 'Failed to export skipped articles. Please try again.',
            merge_modal_title: 'Merge stories',
            merge_modal_helper: 'All articles will be combined into one story. Choose the title to keep.',
            merge_submit: 'Merge stories',
            merge_in_progress: 'Merging stories…',
            merge_close_wont_stop: 'Merge is running in the background. You can safely close this window.',
            merge_article_count: '{count} articles',
            merge_row_in_progress: 'Merging',
            merge_chip: 'Merging {count} stories…',
            merge_pairs_progress: '{done} of {total} stories merged',
            merge_success: 'Stories merged successfully.',
            merge_success_with_count: 'Merged — {count} articles moved to "{name}".',
            merge_failed: 'Failed to merge stories. Please try again.',
            merge_partial_failed: 'Could not merge {names}. Other selected stories were merged.',
            merge_already_in_progress: 'A merge is already in progress for these stories.',
            filters: {
              search_stories: 'Search stories',
              search_stories_placeholder: 'Search by story name…',
              search_articles: 'Search articles',
              search_articles_placeholder: 'Search by headline…',
              risk: 'Risk',
              risk_placeholder: 'All risk levels',
              sentiment: 'Sentiment',
              sentiment_placeholder: 'All sentiments',
              media_type: 'Media type',
              media_type_placeholder: 'All media types',
              country: 'Country',
              country_placeholder: 'All countries',
              country_no_results: 'No countries found',
              status: 'Status',
              status_placeholder: 'All statuses',
              prompt: 'Prompt',
              prompt_placeholder: 'All prompts',
              prompt_none: 'N/A',
              prompt_manual: 'Manual',
              story_count_placeholder: 'All story counts',
              story_count_one: '1',
              story_count_two: '2',
              story_count_three_plus: '3+',
              similar_placeholder: 'All similar',
              similar_yes: 'Similar',
              similar_cluster: 'Similar + parents',
              similar_none: 'N/A',
              period: 'Published (UTC)',
            },
            table: {
              story: 'Story',
              articles: 'Articles',
              first_published: 'First published (UTC)',
              last_published: 'Last published (UTC)',
              date_span: 'Span',
              date_span_days: '{count} day | {count} days',
              date_span_months: '{count} month | {count} months',
              risk: 'Risk',
              sentiment: 'Sentiment',
              last_updated: 'Last updated',
              id: 'ID',
              headline: 'Headline',
              media_type: 'Media type',
              outlet: 'Outlet',
              country: 'Country',
              status: 'Status',
              prompt: 'Prompt',
              stories: 'Stories',
              published: 'Published (UTC)',
              similar: 'Similar',
              similar_articles: 'Similar articles',
            },
          },
          bulk: {
            run_button: 'Backfill Stories',
            modal_title: 'Backfill Stories',
            source_date_range: 'Date Range',
            source_article_ids: 'Article IDs',
            date_range_label: 'Published date range',
            counting: 'Counting articles…',
            article_count: '{count} articles in this range.',
            range_too_wide: 'Date range too wide: {count} articles (max {limit}). Reduce the range.',
            submit: 'Start backfill',
            started_success: 'Stories backfill started.',
            already_running: 'A stories backfill is already running for this project.',
            start_failed: 'Failed to start stories backfill.',
            progress_title: 'Stories backfill in progress',
            finalizing_title: 'Finalizing stories backfill',
            consolidating_title: 'Merging duplicate stories',
            consolidation_round: 'Merge pass',
            consolidation_merges: 'Duplicates merged',
            progress_total: 'Articles',
            progress_stories: 'Stories created',
            progress_jobs: 'Jobs settled',
            progress_source: 'Source',
            progress_range: 'Date range',
            progress_started: 'Started',
            time_elapsed: 'Elapsed',
            time_taken: 'Time taken',
            eta: 'ETA',
            completed: 'Stories backfill completed',
            refresh_story_list: 'Refresh Story List',
            refresh_story_list_tooltip: 'During backfill, similar stories are merged, so the story count can go down as well as up.',
            running_title: 'Backfill running',
            open_backfills: 'Open in Backfills →',
            articles_progress: '{done} of {total} articles',
            eta_minutes: '~{minutes} min left',
          },
          wizard: {
            title: 'Client Dashboard Stories',
            steps: {
              onboarding: 'Onboarding',
              configuration: 'Configuration',
              prompt: 'Prompt',
            },
            status: {
              draft: 'Draft',
              active: 'Active',
              inactive: 'Inactive',
              hidden: 'Archived',
              finishing_backfill: 'Finishing backfill',
            },
            status_tooltip: {
              active: 'Currently used for this dashboard. New articles use this prompt.',
              hidden: 'Archived from Prompt Studio. You can still open it from the Prompts tab, review it, or restore it.',
              draft: 'Started but not finished. Saved so you can continue later.',
              inactive: 'Finished and saved. Not used for new articles. You can activate it again in Prompt Studio, or start a new version from the Versions panel.',
              finishing_backfill: 'No longer used for new articles. A backfill with this prompt is still running. It becomes Inactive when that run finishes.',
            },
            project: 'Project',
            project_tooltip: 'This is the client name. The prompt uses it for context, so keep it accurate and consistent with how the client is referred to elsewhere.',
            sub_sector: 'Sector / Sub-sector',
            sub_sector_placeholder: 'Select sub-sector',
            business_description: 'Business description',
            business_description_tooltip: 'A short plain-English overview of who the client is. Especially useful for smaller or less well-known clients — the model already knows big household names, but this helps it get local or niche businesses right.',
            additional_context: 'Additional information / context',
            additional_context_tooltip: 'Optional. Use this to spell out client-specific risk priorities the model should favour — e.g. “Cybersecurity-related risk should always be treated as top risk for this client.” It builds on the model’s general risk knowledge with what matters most for this account.',
            additional_context_placeholder: 'What represents risk for this client? What would a positive, neutral, and negative story look like for them?',
            generate_configuration: 'Generate configuration',
            generating_configuration: 'Generating configuration',
            reviewing_prompt: 'Reviewing prompt',
            publishing_prompt: 'Finalizing prompt',
            creating_new_version: 'Creating new version',
            new_version: 'New version',
            new_version_panel_title: 'Create new version',
            discard_draft: 'Discard draft',
            discard_draft_confirm_title: 'Discard draft version?',
            discard_draft_confirm_message: '{label} will be discarded and cannot be recovered. Continue?',
            discard_draft_success: 'Draft version discarded successfully.',
            version_delete: 'Delete',
            version_delete_confirm_title: 'Delete this version?',
            version_delete_confirm_message: '{label} will be hidden from Prompt Studio and Overview prompt filters. Past stories keep this prompt. You can restore it from the Prompts tab. Continue?',
            version_delete_success: 'Version removed from this list.',
            version_hide: 'Archive',
            version_hide_confirm: 'Yes',
            version_hide_confirm_title: 'Archive this version?',
            version_hide_confirm_message: '{label} will be archived from Prompt Studio and Overview prompt filters. Past stories keep this prompt. You can restore it from the Prompts tab. Continue?',
            version_hide_success: 'Version archived from Prompt Studio and Overview prompt filters.',
            version_name_edit: 'Edit version name',
            version_name_cancel: 'Cancel editing',
            version_name_save: 'Save version name',
            version_name_save_success: 'Version name saved successfully.',
            version_name_locked: 'Prompt not found or could not be updated.',
            version_rename: 'Rename',
            version_rename_modal_title: 'Rename version',
            back: 'Back',
            next: 'Next',
            finalize: 'Publish prompt',
            finalize_modal_title: 'Publish prompt',
            finalize_modal_subtitle: 'Choose where this prompt should run.',
            finalize_use_for_new_articles: 'Activate for new articles',
            finalize_use_for_new_articles_help: 'Incoming articles are coded with this prompt from now on. Stories start appearing going forward.',
            finalize_backfill_existing: 'Backfill past articles',
            finalize_backfill_existing_help: 'Re-process articles from a past date range so stories appear historically. Replaces any earlier coding on those articles.',
            finalize_backfill_attention_title: 'Attention:',
            finalize_backfill_attention_body: 'backfilling re-processes every article in the selected range. Existing Stories on those articles will be deleted and replaced by new Stories generated with this prompt.',
            finalize_replace_active_title: 'Replaces the current prompt.',
            finalize_replace_active_body: '{label} will stop applying to new articles. Past stories keep their existing coding.',
            finalize_outcome_both_title: 'Activate and backfill.',
            finalize_outcome_both_body: 'New articles use this prompt, and articles in the selected range are re-processed now.',
            finalize_outcome_activate_title: 'Activate for new articles.',
            finalize_outcome_activate_body: 'Stories appear going forward. Past articles are untouched.',
            finalize_outcome_backfill_title: 'Backfill only.',
            finalize_outcome_backfill_body: 'Articles in the selected range are re-processed. This version is stored as Inactive. You can activate it later in Prompt Studio.',
            finalize_outcome_draft_title: 'Keep as draft.',
            finalize_outcome_draft_body: 'Nothing runs. This version stays a Draft so you can publish it later.',
            finalize_outcome_inactive_title: 'Leave Inactive.',
            finalize_outcome_inactive_body: 'Nothing runs. This version stays Inactive. Tick Activate to restore it for new articles, or use New version in the Versions panel to start a fresh draft.',
            finalize_outcome_retire_title: 'Save as Inactive.',
            finalize_outcome_retire_body: 'This prompt will stop applying to new articles. Past stories keep their existing coding. You can Activate it again later.',
            finalize_primary_both: 'Activate & backfill',
            finalize_primary_activate: 'Activate',
            finalize_primary_backfill: 'Run backfill',
            finalize_primary_draft: 'Keep as draft',
            finalize_primary_inactive: 'Leave Inactive',
            finalize_primary_retire: 'Save as Inactive',
            finalize_save_as_draft_instead: 'Keep as draft instead',
            finalize_stats: '{name} · {model} · Articles: {count}',
            finalize_inactive_success: 'Prompt saved as Inactive. New articles will not use this prompt.',
            finalize_backfill_started: 'Backfill started. Stories will appear on the Stories tab as they are coded.',
            story_identification_title: 'What a Story is for {project_name}',
            risk_rubric_title: 'What risk means for {project_name}',
            risk_rubric_edit: 'Edit risk rubric',
            risk_rubric_cancel: 'Cancel editing',
            risk_rubric_save: 'Save risk rubric',
            risk_rubric_save_success: 'Risk rubric saved successfully.',
            risk_rubric_locked: 'Risk rubric can no longer be edited because a prompt has been generated or this version is locked.',
            sentiment_guide_edit: 'Edit sentiment guide',
            sentiment_guide_cancel: 'Cancel editing',
            sentiment_guide_save: 'Save sentiment guide',
            sentiment_guide_save_success: 'Sentiment guide saved successfully.',
            sentiment_guide_locked: 'Sentiment guide can no longer be edited because this version is locked.',
            risk_levels: {
              1: 'No risk',
              2: 'Low',
              3: 'Moderate',
              4: 'Elevated',
              5: 'High',
            },
            sentiment_guide_title: 'How story sentiment reads for {project_name}',
            sentiment_levels: {
              negative: 'Negative',
              neutral: 'Neutral',
              positive: 'Positive',
            },
            reasoning_effort_label: 'Reasoning effort (config generation)',
            reasoning_effort_prompt_label: 'Reasoning effort (prompt generation)',
            advanced_ai_settings: 'Advanced AI settings',
            versions_title: 'Versions',
            versions_updated_by: 'Updated by {name} at {date}',
            versions_updated_at: 'Updated at {date}',
            loading_version: 'Loading version',
            loading_wizard: 'Loading…',
            reasoning: {
              low: 'Low',
              medium: 'Medium',
              high: 'High',
            },
            tokens_config: 'Config',
            tokens_prompt: 'Prompt',
            intake_sufficiency: {
              high: 'Configuration confidence: High',
              medium: 'Configuration confidence: Medium',
              low: 'Configuration confidence: Low',
              high_tooltip: 'The details you provided are enough for the AI to write prompts with confidence. You can still refine them, but nothing extra is required.',
              medium_tooltip: 'The AI isn\'t confident yet — the client may be small, not well-known, or the name could match more than one thing. Add more in Business Description and Additional Information, then come back.',
              low_tooltip: 'The AI isn\'t confident yet — the client may be small, not well-known, or the name could match more than one thing. Add more in Business Description and Additional Information, then come back.',
            },
            prompt_step_title: 'Prompt',
            prompt_step_description: 'This is the assembled prompt preview. Article headline and body are runtime placeholders.',
            backfill_status_label: 'Article status',
            backfill_status_placeholder: 'Select article status',
            backfill_articles_counting: 'counting…',
            backfill_load_count: 'Count articles',
            backfill_count_required: 'Count matching articles before Activate & backfill is available.',
            backfill_filters_help: 'Select a published date range and article statuses, then count matching articles.',
            backfill_run_in_progress: 'A run is currently in progress for this project ({percent}% complete). Starting a new run is disabled until it finishes or is cancelled.',
            backfill_view_in_overview: 'View in Stories →',
            worked_examples_title: 'Worked examples',
            system_message: 'System message',
            user_message: 'User message',
            publish_success: 'Prompt is now Active. New articles will use this prompt.',
            new_version_success: 'New draft version created.',
            validation: {
              project_required: 'Project is required',
              sub_sector_required: 'Sector / sub-sector is required',
              business_description_required: 'Business description is required',
            },
            errors: {
              load_failed: 'Failed to load saved wizard data. Please refresh the page.',
              onboarding_failed: 'Failed to generate configuration. Please try again.',
              prompt_failed: 'Failed to generate prompt. Please try again.',
              publish_failed: 'Failed to finalize prompt. Please try again.',
              finalize_missing_uuid: 'This prompt is missing a uuid, so backfill cannot run. Reload the page and try again.',
              new_version_failed: 'Failed to create new version. Please try again.',
              version_load_failed: 'Failed to load version. Please try again.',
              discard_draft_failed: 'Failed to discard draft version. Please try again.',
              version_delete_failed: 'Failed to delete version. Please try again.',
              version_delete_has_stories: 'This prompt cannot be deleted while stories are attached to it.',
              risk_rubric_failed: 'Failed to save risk rubric. Please try again.',
              sentiment_guide_failed: 'Failed to save sentiment guide. Please try again.',
              version_name_failed: 'Failed to save version name. Please try again.',
              version_name_too_long: 'Version name must be at most {max} characters.',
            },
          },
        },
        geo: {
          title: 'AI Visibility',
          nav: 'AI Visibility',
          tabs: {
            dashboard: 'Dashboard',
            audit: 'Audit',
          },
          messages: {
            loading: 'Loading AI Visibility workspace...',
            prompts_generated: 'Prompts generated successfully.',
            prompts_uploaded: 'Prompts uploaded successfully.',
            prompts_saved: 'Prompts saved successfully.',
            dashboard_saved: 'AI Visibility dashboard saved successfully.',
          },
          errors: {
            projects_failed: 'Failed to load CARMA AI projects. Please refresh the page.',
            load_failed: 'Failed to load AI Visibility dashboards. Please refresh the page.',
            setup_required: 'Add a brand name and select at least one model before continuing.',
            prompt_generation_failed: 'Failed to generate prompts. Please try again.',
            prompt_upload_failed: 'Failed to upload prompts. Please try again.',
            prompt_save_failed: 'Failed to save prompts. Please try again.',
            prompts_required: 'Add at least one prompt before saving.',
            execute_failed: 'Failed to start the AI Visibility run. Please try again.',
            execution_timeout: 'The dashboard is still processing. Open the dashboard again in a moment.',
            analytics_failed: 'Failed to load AI Visibility analytics. Please refresh the page.',
            audit_failed: 'Failed to load AI Visibility audit data. Please refresh the page.',
            export_failed: 'Failed to export the workbook. Please try again.',
          },
          statuses: {
            unknown: 'Unknown',
            lifecycle: {
              draft: 'Draft',
              published: 'Published',
              archived: 'Archived',
              deleted: 'Deleted',
            },
            execution: {
              queued: 'Queued',
              running: 'Running',
              completed: 'Completed',
              completed_with_errors: 'Completed with issues',
              failed: 'Failed',
            },
          },
          breadcrumb_projects: 'Projects',
          projects: {
            title: 'Choose a project',
            description: 'Select the project that owns the AI Visibility dashboard setup and results.',
            search: 'Search projects',
            search_placeholder: 'Project or client name',
            search_action: 'Search',
            load_more: 'Load more',
            empty_title: 'No projects found',
            empty_description: 'Try changing the search term or check project eligibility.',
          },
          dashboard_list: {
            title: 'Dashboards',
            add_dashboard: 'Dashboard',
            search_placeholder: 'Search...',
            empty: 'No dashboards found',
            empty_archived: 'No archived dashboards',
            empty_count: '0 Results',
            count: '{total} Results',
            name: 'Dashboard names',
            brand: 'Brand',
            status: 'Status',
            last_updated: 'Last updated',
            actions: 'Actions',
            view: 'View',
            edit: 'Edit',
            tab_dashboards: 'Dashboards',
            tab_archive: 'Archive',
            archive: 'Archive',
            archived_label: 'Archived',
            archive_confirm: 'Are you sure you want to archive this dashboard?',
            archive_success: 'Dashboard archived successfully.',
            archive_failed: 'Failed to archive dashboard. Please try again.',
            delete: 'Delete',
            delete_draft: 'Delete',
            delete_draft_confirm: 'Are you sure you want to delete this draft dashboard?',
            delete_draft_success: 'Draft dashboard deleted.',
            delete_draft_failed: 'Failed to delete draft. Please try again.',
            delete_archived_confirm: 'Are you sure you want to permanently delete this archived dashboard?',
            delete_archived_success: 'Archived dashboard deleted.',
            delete_archived_failed: 'Failed to delete archived dashboard. Please try again.',
          },
          setup: {
            wizard_title: 'Creating Dashboard',
            steps_label: 'Dashboard creation steps',
            steps: {
              details: 'Details',
              brand: 'Your brand',
              competition: 'Competition',
              prompts: 'LLMs & Prompts',
              review: 'Review',
            },
            title: 'Configure your perception run',
            description: 'Define your brand, competitors, prompts, and models, then run grounded queries across the major AI assistants.',
            dashboard: 'Dashboard',
            new_dashboard: 'New dashboard',
            open_results: 'Open results',
            details_title: 'Details',
            dashboard_name: 'Dashboard name',
            dashboard_name_placeholder: 'Dashboard name',
            dashboard_description: 'Description',
            dashboard_description_placeholder: 'Brief description of this dashboard',
            update_frequency: 'Update frequency',
            brand_title: 'Brand and competitors',
            brand_description: 'Competitors are optional, up to five.',
            brand_step_title: 'Your Brand',
            brand_step_description: 'Define your brand, market/region, and topic of interest.',
            brand_name: 'Brand name',
            brand_name_placeholder: 'Your brand name',
            competitors: 'Competitors',
            competitor_placeholder: 'Competitor {index}',
            competition_step_title: 'The Competition',
            competition_step_description: 'Define your competition.',
            add_competitor: 'Add a new competitor',
            market_region: 'Market / Region (optional)',
            market_region_placeholder: 'e.g. North America, EMEA, UK healthcare market',
            topic: 'Topic of interest (optional)',
            topic_placeholder: 'Describe the topic which best suits your brand',
            save_hint: 'Setup and prompts are saved only when you click Save or Generate dashboard.',
            edit_locked_hint: 'This setup is locked after saving. You can still edit prompts below.',
            providers_title: 'Choose LLMs',
            providers_description: 'Select providers and see the exact model used for each one.',
            llms_prompts_title: 'LLMs & Prompts',
            llms_prompts_description: 'Choose your preferred LLMs and define prompts.',
            choose_llms: 'Choose your LLMs',
            model: 'Model',
            selected_models: 'Selected models for this run',
            no_models: 'No models selected.',
            preview_title: 'Preview',
            preview_description: 'You are previewing the AI Visibility dashboard',
            not_set: 'Not set',
            none_added: 'None added',
            back: 'Back',
            next: 'Next',
            delete_draft: 'Delete draft',
            draft_deleted: 'Draft dashboard deleted.',
            draft_delete_failed: 'Failed to delete draft. Please try again.',
            saving_setup: 'Saving setup...',
            running_queries: 'Running queries and building analytics...',
            complete: 'complete',
          },
          prompts: {
            title: 'Prompts',
            description: 'Generate 10 questions, upload prompts from Excel, or manage them manually.',
            generate: 'Generate prompts',
            generating: 'Generating prompts...',
            upload: 'Upload Excel',
            uploading: 'Uploading prompts...',
            prompt_placeholder: 'Question shown to the model',
            empty_title: 'No prompts yet',
            empty_description: 'Generate from your brand setup, upload a column of questions from Excel, or add prompts manually.',
            add: 'Add prompt',
            save: 'Save prompts',
            edit: 'Edit prompts',
            cancel_edit: 'Cancel edit',
            save_version: 'Save new version',
            save_dashboard: 'Save dashboard',
            saving: 'Saving prompts...',
            run: 'Generate dashboard',
            preview_results: 'Preview results',
            run_now: 'Run now',
            readonly_hint: 'Prompts are read-only for saved dashboards. Click Edit prompts to create a new version.',
            versions_title: 'Prompt versions',
            versions_description: 'Every prompt save is preserved so previous dashboard runs stay tied to the prompts used at the time.',
            version_label: 'Version {version}',
            active_version: 'Active',
            prompts_count: 'prompts',
          },
          dashboard: {
            title: 'AI Visibility dashboard',
            export_qa: 'Export Q&A',
            audit: 'Audit',
            publish: 'Publish',
            publish_success: 'Dashboard published successfully.',
            publish_failed: 'Failed to publish dashboard. Please try again.',
            edit_rerun: 'Edit & Rerun',
            edit_rerun_confirm: 'This will delete all existing execution results so you can edit the full dashboard setup. Continue?',
            run_now_confirm: 'An execution already completed today. Running again will delete today\'s existing results and start fresh. Continue?',
            run_now_in_progress: 'An execution is already in progress. Please wait for it to complete.',
            edit_rerun_failed: 'Failed to prepare dashboard for editing. Please try again.',
            discard_success: 'Execution results discarded.',
            ai_visibility: 'AI visibility',
            smart_summary: 'Smart summary',
            visibility: 'Visibility',
            sentiment_positive: 'Positive',
            sentiment_neutral: 'Neutral',
            sentiment_negative: 'Negative',
            avg_position: 'Avg Position',
            sentiment: 'Sentiment',
            prompt_coverage: 'Prompt coverage',
            citation_rate: 'Citation rate',
            top_llm: 'Top LLM',
            filter_all: 'All',
            last_updated: 'Last updated',
            cycle_count: 'Cycle count',
            token_used: 'Token used',
            visibility_trend: 'Visibility trend over time',
            chart_client: 'Client',
            chart_competitors: 'Competitors',
            avg_rank: 'Average rank',
            avg_sentiment: 'Avg sentiment',
            executive_summary: 'Executive summary',
            brand_visibility: 'Brand visibility',
            brand_visibility_description: 'Visibility and share of voice across tracked brands.',
            sov: 'SOV',
            model_comparison: 'Model comparison',
            model_comparison_description: 'Provider-level visibility, citation, and sentiment signals.',
            responses: 'Responses',
            prompt_performance: 'Prompt performance',
            prompt_performance_description: 'Expand each prompt to inspect provider answers and citations.',
            no_results: 'No results yet',
            no_results_description: 'Run this dashboard to populate analytics.',
            rank: 'Rank',
            no_answer: 'No answer text returned.',
          },
          schedule: {
            title: 'Scheduled runs',
            description: 'Configure automatic execution on a recurring schedule.',
            enable: 'Enable scheduled runs',
            frequency: 'Frequency',
            daily: 'Daily',
            weekly: 'Weekly',
            monthly: 'Monthly',
            time: 'Time',
            day_of_week: 'Day(s) of week',
            day_of_month: 'Day of month',
            timezone: 'Timezone',
            end_date: 'End date',
            end_date_hint: 'Optional. Runs through this date, then stops. Leave empty for no end date.',
            save: 'Save schedule',
            remove: 'Remove schedule',
            saving: 'Saving schedule...',
            save_success: 'Schedule saved successfully.',
            remove_success: 'Schedule removed.',
            save_failed: 'Failed to save schedule. Please try again.',
            last_run: 'Last run',
            not_scheduled: 'Not scheduled',
            scheduled_label: 'Scheduled',
            days: {
              sun: 'Sun',
              mon: 'Mon',
              tue: 'Tue',
              wed: 'Wed',
              thu: 'Thu',
              fri: 'Fri',
              sat: 'Sat',
            },
          },
          estimate: {
            title: 'Cost Estimate',
            description: 'Estimated execution cost based on your configuration.',
            config_title: 'Configuration',
            prompts_label: 'Prompts',
            providers_label: 'Providers',
            brands_label: 'Brands tracked',
            cost_title: 'Estimated Cost per Execution',
            tokens_label: 'tokens',
            search_label: 'search',
            analysis_label: 'Analysis (all jobs)',
            total_label: 'Total',
            gemini_alert: 'Gemini introductory pricing ends Jan 1, 2027. After that date, this provider\'s cost will increase to {postCost} (+{increase}).',
            disclaimer: 'Estimate based on typical usage (Average). Actual cost may vary \u00b120\u201330%.',
            no_selection: 'Select at least one provider and one prompt to see the cost estimate.',
          },
          audit: {
            title: 'Response audit',
            loading_title: 'Loading audit',
            description: 'Internal metadata for model resolution, grounding, citations, token usage, and errors.',
            back_to_dashboard: 'Back to dashboard',
            export: 'Export audit',
            filters: 'Filters',
            provider: 'Provider',
            all_providers: 'All providers',
            execution: 'Execution',
            all_executions: 'All executions',
            from_date: 'From date',
            to_date: 'To date',
            limit: 'Limit',
            apply_filters: 'Apply filters',
            rows: 'Rows',
            errors: 'Errors',
            citations: 'Citations',
            tokens: 'Tokens',
            responses: 'Responses',
            generated_at: 'Generated {date}',
            prompt: 'Prompt',
            grounding: 'Grounding',
            used: 'Used',
            not_used: 'Not used',
            answer: 'Answer',
            no_rows: 'No audit rows found.',
          },
        }
      }
    }
  }
  
  module.exports.carmaAi = carmaAi;